import base64 from 'config/base64'

export default (credentials) => {
  const headers = {}

  if (credentials) {
    let authorization
    if (typeof (btoa) !== 'undefined') {
      authorization = `Basic ${btoa(`${credentials.email}:${credentials.password}`)}`
    } else {
      authorization = `Basic ${base64.encode(`${credentials.email}:${credentials.password}`)}`
    }
    headers.authorization = authorization
  }
  return headers
}



// WEBPACK FOOTER //
// ./src/utils/login/basicHeadersBuilders.js